import { render, staticRenderFns } from "./LetterheadPaper.vue?vue&type=template&id=43a240d8&"
import script from "./LetterheadPaper.vue?vue&type=script&lang=js&"
export * from "./LetterheadPaper.vue?vue&type=script&lang=js&"
import style0 from "./LetterheadPaper.vue?vue&type=style&index=0&id=43a240d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports